import { render, staticRenderFns } from "./FileUploadArea.vue?vue&type=template&id=54701610&scoped=true"
import script from "./FileUploadArea.vue?vue&type=script&lang=js"
export * from "./FileUploadArea.vue?vue&type=script&lang=js"
import style0 from "./FileUploadArea.vue?vue&type=style&index=0&id=54701610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54701610",
  null
  
)

export default component.exports